import { useEffect, useState } from 'react'
import { getServicingHold } from 'services'

/**
 * Whether the loan is on servicing Hold.
 *
 * Hold is enforced server-side: the save is rejected whatever the screen shows. What the screen
 * owes the user is the warning, before they have filled in a payment the platform was never going
 * to accept. A failed lookup reports "not held" rather than blocking a screen over a side request.
 *
 * Loan-scoped through the shared Api loan-number header, so only call it from a screen that is
 * already pointed at the loan.
 */
export const useServicingHold = () => {
  const [onHold, setOnHold] = useState(false)

  useEffect(() => {
    let cancelled = false
    getServicingHold()
      .then((res: any) => {
        if (!cancelled) setOnHold(!!res?.onHold)
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [])

  return onHold
}

/** The banner a transaction screen shows while its loan is held. */
export const ServicingHoldBanner = ({ action = 'Payments and borrower communications' }: { action?: string }) => (
  <div className="mb-3 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900">
    <span className="font-semibold">This loan is on Hold.</span> {action} are blocked until the Hold is removed on the
    Servicing Information screen.
  </div>
)
